//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EncodeHtmlCalculations: FeatureFlag = {"Id":"EncodeHtmlCalculations","Label":"[10.13]Encode HTML calculation","Impact":"Treat the result of calculations injected into HTML as plain text (I.E. HTML encode it)","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
